import { render, staticRenderFns } from "./FileGeneratorButton.vue?vue&type=template&id=4a1c277d&scoped=true"
import script from "./FileGeneratorButton.vue?vue&type=script&lang=ts"
export * from "./FileGeneratorButton.vue?vue&type=script&lang=ts"
import style0 from "./FileGeneratorButton.vue?vue&type=style&index=0&id=4a1c277d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1c277d",
  null
  
)

export default component.exports